import PropTypes from 'prop-types';

const Price = (props) => {

    return (
        "$ " + (Math.round(props.price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    )
};

Price.propTypes = {
    price: PropTypes.number
};

export default Price;
